<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable width="1200px" persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          {{ $t("NewUpdate.announ6") }}
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            style="float: right"
            @click="Fn_Close()"
          >
            {{ $t("consentform.close") }}</v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-2">
          <v-tabs
            background-color="transparent"
            v-model="tab"
            align-with-title
            color="white"
          >
            <v-tab
              v-for="item in itemsAnnounce"
              :key="item"
              :style="'color:white;background-color:' + item.color"
            >
              {{ item.text }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-layout
                row
                wrap
                justify-end
                align-end
                mt-4
                mb-4
                v-if="StatusNotAvailable || NotAvailable.length > 0"
              >
                <v-flex xs3 sm3 md2 lg2>
                  <v-btn
                    rounded
                    color="#077893"
                    dark
                    :loading="LoadingSentConsent"
                    @click="Fn_ConfirmConsent()"
                  >
                    {{ $t("onechat.send") }}</v-btn
                  >
                </v-flex>
              </v-layout>
              <v-card outlined>
                <v-card-text
                  class="pa-1"
                  style="max-height: 500px; overflow: auto"
                >
                  <v-data-table
                    v-if="StatusNotAvailable || NotAvailable.length > 0"
                    :headers="headersNotAvailable"
                    :items="NotAvailable"
                    hide-default-footer
                    @page-count="PageCount = $event"
                    :page.sync="Page"
                    :items-per-page="rowPerpage"
                    class="pa-5"
                  >
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="mb-5">
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 lg11 md11 sm11>
                      <v-pagination
                        total-visible="10"
                        circle
                        color="#077893"
                        v-model="Page"
                        :length="PageCount"
                      >
                      </v-pagination>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card outlined class="mt-4">
                <v-card-text
                  class="pa-1"
                  style="max-height: 500px; overflow: auto"
                >
                  <v-data-table
                    :headers="headersAvailable"
                    :items="Available"
                    hide-default-footer
                    :items-per-page="rowPerpageAvailable"
                    :page.sync="PageAvailable"
                    @page-count="PageCountAvailable = $event"
                    class="pa-5"
                  >
                    <template v-slot:[`item.NameTh`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.NameTh }}
                      </div>
                      <div v-else>
                        {{ item.NameEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.SendAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.SendAtTh }}
                      </div>
                      <div v-else>
                        {{ item.SendAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdateAtTh }}
                      </div>
                      <div v-else>
                        {{ item.UpdateAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.SendStatus`]="{ item }">
                      <v-chip
                        color="green"
                        dark
                        v-if="item.SendStatus === 'OK'"
                        >{{ $t("onechat.status4") }}</v-chip
                      >
                      <v-chip
                        color="error"
                        dark
                        v-else-if="item.SendStatus === 'ER'"
                        >{{ $t("onechat.status3") }}</v-chip
                      >
                      <v-chip
                        color="warning"
                        dark
                        v-else-if="item.SendStatus === 'WAIT'"
                        >{{ $t("onechat.status7") }}</v-chip
                      >
                      <v-chip
                        color="indigo"
                        dark
                        v-else-if="item.SendStatus === 'Read'"
                        >{{ $t("onechat.status5") }}</v-chip
                      >
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-card-actions class="mb-5">
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 lg11 md11 sm11>
                      <v-pagination
                        total-visible="10"
                        circle
                        color="#077893"
                        v-model="PageAvailable"
                        :length="PageCountAvailable"
                      >
                      </v-pagination>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <DialogListAnnounce
      :show="DialogListGeneral"
      :_detail="ItemsConsent"
      @closeDialogDelete="DialogListGeneral = false"
    />
  </v-row>
</template>
<script>
import DialogListAnnounce from "@/components/dialog/Announce/Onechat/DialogListAnnounceCreate.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  props: ["show", "_detail"],
  components: {
    DialogListAnnounce,
  },
  data: function () {
    return {
      Page: 1,
      PageCount: 0,
      rowPerpage: 10,
      PageAvailable: 1,
      PageCountAvailable: 0,
      rowPerpageAvailable: 10,
      tab: "",
      itemsAnnounce: [
        { text: this.$t("NewUpdate.announ7"), color: "#4DB6AC" },
        { text: this.$t("NewUpdate.announ8"), color: "#EF5350" },
      ],
      LoadingSentConsent: false,
      Available: [],
      NotAvailable: [],
      ItemsConsent: [],
      StatusNotAvailable: false,
      DialogListGeneral: false,
      serviceEmail: "",
      SelectConsentGroup: "",
      SelectConsentGeneral: "",
    };
  },
  created() {},
  computed: {
    ...mapGetters(["DataGroupConsent"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
    _profile: {
      get() {
        return this.$store.getters.profile;
      },
    },
    _apiKey: {
      get() {
        return this.$store.getters.apikey;
      },
    },
    _accesskey: {
      get() {
        return this.$store.getters.accessKey;
      },
    },
    headersNotAvailable: {
      get() {
        return [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "row",
            align: "center",
            sortable: false,
          },
          {
            text: this.$i18n.t("Profile.accountId"),
            value: "AccountId",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.name"),
            value: "NameTh",
            align: "left",
            sortable: false,
          },
        ];
      },
    },
    headersAvailable: {
      get() {
        return [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "row",
            align: "center",
            sortable: false,
          },
          {
            text: this.$i18n.t("Profile.accountId"),
            value: "AccountId",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.name"),
            value: "NameTh",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("consentlist.date"),
            value: "SendAt",
            align: "center",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.date"),
            value: "UpdatdeAt",
            align: "center",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.status"),
            value: "SendStatus",
            align: "center",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.Note"),
            value: "Message",
            align: "center",
            sortable: false,
          },
        ];
      },
    },
    _SendId: {
      get() {
        return this.DataGroupConsent.SendId || "-";
      },
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.Available = this._detail.Available;
        this.NotAvailable = this._detail.NotAvailable;
        this.fn_setData();
        var Status = this.NotAvailable.find((item) => item.Status === true);
        this.StatusNotAvailable = Status;
      }
    },
  },
  mounted() {},
  methods: {
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    fn_setData() {
      for (var j in this.NotAvailable) {
        this.NotAvailable[j].row = parseInt(j) + 1;
      }
      for (var i in this.Available) {
        this.Available[i].row = parseInt(i) + 1;
      }
    },
    Fn_Close() {
      this.$emit("closeDialogDelete");
    },
    async Fn_ConfirmConsent() {

      this.LoadingSentConsent = true;
      for (var i in this.NotAvailable) {
        delete this.NotAvailable[i].Status;
        delete this.NotAvailable[i].Message;
      }
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        Receiver: this.NotAvailable,
        TransactionId: this._DataGroupOneChatSearch.TransactionId,
        AccessToken: this.$cookies.get("OneAccessToken"),
        UserId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/SendAnnounceAddOn",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingSentConsent = false;
          if (response.data.Status === "OK") {
            this.$emit("closeDialogDelete");
            this.ItemsConsent = response.data.Message;
            this.DialogListGeneral = true;
          } else {
            this.LoadingSentConsent = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.noteStlye {
  width: 150px;
  word-wrap: break-word;
}
</style>
